import React from 'react';
import { useIntl } from 'hooks/intl';

export interface FpFormattedMessageProps {
  id: string
  values?: string[]
}

export function FpFormattedMessage(props: FpFormattedMessageProps) {
  const intl = useIntl();

  return (<span>{ intl.formatMessage(props.id, props.values) }</span>);
}
